<div class="date-range-banner" *ngIf="showDateRangeBanner">
	<div class="banner-content">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			style="margin-right: 8px; flex-shrink: 0"
		>
			<path
				d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
				fill="#00AAFF"
			/>
			<path
				d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
				fill="#00AAFF"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
				fill="#00AAFF"
			/>
		</svg>
		<div class="banner-text">
			Some lift values may be skewed due to historical data limits (only past 2 years + 1 quarter available)
		</div>
	</div>
</div>

<div class="campaign_names" *ngIf="campaignsList.length > 1 && campaignCarouselItem">
	<div class="campaign-header-name {{ sectionclass }}">
		<div class="lift-title ellipsis">
			<span
				appTooltip
				title="{{ campaignCarouselItem.campaign_name }}"
				class="full-text"
				[title]="campaignCarouselItem"
				data-size="small"
				[options]="tooltipOptions"
				>{{ campaignCarouselItem.campaign_name }}</span
			>
		</div>
		<div class="navigators">
			<div class="left-arrow">
				<a class="u-opacity-50p lift-icon">
					<span class="next" (click)="prevArrow()" class="carousel-arrow-style">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</span>
				</a>
			</div>
			<div class="right-arrow">
				<a class="u-opacity-50p lift-icon">
					<span class="prev" (click)="nextArrow()" class="carousel-arrow-style">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</span>
				</a>
			</div>
		</div>
	</div>
</div>

<div class="campaign_names" *ngIf="campaignsList.length === 1 && campaignCarouselItem">
	<div class="campaign-header-name {{ sectionclass }}">
		<div class="left-arrow"></div>
		<div class="lift-title ellipsis">
			<span class="full-text">{{ campaignCarouselItem.campaign_name }}</span>
		</div>
		<div class="right-arrow"></div>
	</div>
</div>

<div class="row">
	<app-loader [showLoader]="showLoad || showLoad1"></app-loader>
	<div class="column">
		<div class="c-portlet o-block stats-container-lift">
			<div *ngIf="hasLiftData" class="set_background_color">
				<div class="lift_quick_stats_portlet_content stats_content">
					<div class="lift_stats_subtitle">
						People who saw your digital ads are
						<span *ngIf="liftStatsData" class="majorText">{{ liftStatsData.digitalLift }}</span>
						x more likely to visit your website.
					</div>
				</div>
				<div class="no-data-container" *ngIf="!hasData1">
					<div class="map-no-data no-data-text">No Data to Display</div>
				</div>
			</div>
		</div>
	</div>

	<div class="column">
		<div
			class="charts-container product-lift-chart-container"
			*ngIf="campaignCarouselItem && hasData"
			[id]="'campaign' + campaignCarouselItem.campaign_id"
		>
			<app-generic-chart
				*ngIf="graphData?.length"
				[configuration]="chartConfig"
				[data]="graphData"
				[colorPalette]="colorPalette"
			>
			</app-generic-chart>
		</div>
	</div>
	<div class="no-data-container" *ngIf="!hasData || !hasData1">
		<div class="u-px-small no_lift_data_block stats_content no-data-text">
			<div class="lift_stats_subhead">Campaigns in the selected date range are not eligible for lift reporting.</div>
			<div class="lift_stats_sub_section">
				<div>A campaign must meet all of the following 3 requirements to receive lift reporting</div>
				<div class="list_items">
					<ol>
						<li>1.Campaign must have the pixel placed and firing on the website</li>
						<li>2.Campaign must run for 3 consecutive months</li>
						<li>3.Campaign must run at least 50,000 audience extension impressions per month</li>
					</ol>
				</div>
			</div>
		</div>
	</div>
</div>
